@import 'styles/mixins';
@import 'styles/variables';
@import 'styles/blaze/mixins';

.container {
  padding-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cardContainer {
  border-radius: 5px;
  background: var(--Light-100, #fff);
  /* Container Shadow */
  box-shadow: 1px 1px 0px 0px rgba(255, 255, 255, 0.9) inset, 0px 2px 12px 0px rgba(0, 0, 0, 0.04);
  backdrop-filter: blur(35px);
  display: flex;
  align-items: center;
  width: fit-content;
  padding: 7px 10px;
  font-family: Sohne;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 22.4px */
  letter-spacing: 0.48px;
  text-transform: uppercase;

  & svg {
    margin-right: 10px;
  }

  & p {
    margin-bottom: 0;
  }
}

.obscured {
  color: var(--dark-15, rgba(0, 0, 0, 0.15));
  margin-right: 4px;
}
